export enum EnumSizeScreen {
  small = 212,
  medium = 237,
  large = 270,
}
